export default "__VITE_ASSET__LebT$OYz__"